<div class="blog-post-card" [routerLink]="['/post', post._id]">
  <div class="image-wrapper">
    <ion-img [src]="post?.imageUrl" alt="Satel Realty Riyadh"></ion-img>
  </div>
  <div class="content">
    <span class="date">{{  post?.eventDate ?? post?.posted | date: 'MMMM dd, yyyy' }}</span>
    <h3>{{ post.title }}</h3>
    <p [innerHTML]="post.post"></p>
<!--    <a [routerLink]="['/post', post._id]">Read more</a>-->
  </div>
</div>
